const _en = {};

_en.createForm = {
  'header.title': 'Create template',
  'header.description': 'Templates can be saved and reused.',
  'header.details.description': 'You can add up to 20 fields.',
  'custInfo.heading': 'Capture Additional Information from customer',
  'linkInfo.placeholder': 'Description',
  'templateName.placeholder': 'Template Name',
  'linkInfo.helpText':
    'You can enter instructions for filling the details. This would be shown to the user before filling the details.',
  'define.amount': 'Define how customer Pays you',
  'collect.additional':'Collect Additional Information from customer',
  'addField': '+ Add Information Field',
  'template.details':'Template Details',
  'payment.details': 'Define how customer Pays you',
  'amountField': '+ Add Type of Amount Field',
  'select.info.field': 'Select customer information type',
  'edit.header.title': 'Edit payment template'
};

_en.addField = {
  'header.title': 'Add field for customer information',
  'header.description': 'You can either select from the suggested list or create a custom field.',
  'customField.button': '+ Add Another option',
  'button': 'Add field',
  'errMsg': 'You can add upto 10 fields in a template',
  'customField.one.button':'+ Add option',
  'save.field':'Save field',
  'field.details':'Add Field details',
  'option.prefix':'Option',
  'another.info':'+ Add Another Information Field',
  'another.amount':'+ Add Another Amount Field',
  'select.info.field':'Select customer information type',
  'select.amount.field':'Select Type of Amount Field',
  'feild.validation':'FIELD VALIDATION',
};

_en.amountField = {
  'header.title': 'Add Custom Amount field',
  'header.description': 'You can choose between the given amount types and customize it',
  subHeading: 'Type of Amount Field',
  'quantity.amount': 'SET ORDER QUANTITY LIMITS',
  'flexible.amount': 'SET ALLOWED AMOUNT THAT YOUR CUSTOMERS CAN ENTER',
  error: "can't be greater than",
  'edit.button': 'Save field',
  'edit.title': 'Edit field',
  'edit.description': 'You can customize the field according to your business requirement',
  'fixed.description': 'Customer pays the amount entered by you',
  'amount.description': 'Set a price for your product or service. Your customers will be able to choose the quantity',
  'flexible.description': 'Your customer can choose the amount they wish to pay',
  'select.amount.field': 'Select Type of Amount Field',
  'amount.greater.error': `Min Quantity can't be greater than Max Quantity`,
  'mandatory.quantity': 'For mandatory Add product or service field, min quantity must be greater than 0',
  'min.amount': 'Min Amount',
  'max.amount': 'Max Amount',
  'min.quantity': 'Min Quantity',
  'max.quantity': 'Max Quantity',
  'amount.min.max.error': `Min Amount can't be greater than Max Amount`,
  optional: 'Optional'
};

_en.customDate = {
  'invalid.error': "Min Date can't be greater than Max Date",
  'min.date': 'Min Date',
  'max.date': 'Max Date'
};

_en.createField = {
  'mandatory.label': 'It is mandatory for the customer to fill this field',
  'help.label': 'I want to add a help text for this field',
  'maxDate.label': 'Your customers will not be able to select a date greater than the day of payment',
  'minDate.label': 'Your customers will not be able to select a date lesser than the day of payment',
  'date.label': 'Transaction Date',
  'select.field.validation': 'Select Field Validation',
  'short.text': 'upto 30 chars',
  'long.text': 'upto 200 chars',
  'fixed.length': 'Fixed Length',
  'custom.empty.error': 'Please choose a field validation',
  'custom.no.options.error': 'Please add dropdown options',
  'custom.two.options.error': 'Please add at least two options',
  'view.field.preview': 'View field preview',
  text: 'Text',
  numeric: 'Numeric',
  dropdown: 'Dropdown',
  date: 'Date',
  field: 'field'
};

_en.static = {
  'dialog.info': 'Remove Field',
  'dialog.description': 'Are you sure you want to remove the field from the list of suggestions?',
  'dialog.yes': 'Confirm',
  'yes': 'Yes',
  'change.button': 'Change Button Type',
  'confirmation': 'All changes would be lost. Do you want to proceed?',
  'dialog.no': 'Cancel',
  'deleteApi.failMsg': 'The chosen field is not deleted. Please retry again...',
  'saveApi.failMsg': 'The form is not submitted. Please retry again...',
  'characters.remaining':'characters remaining',
  'editField.header.title':"Edit field",
  'editField.header.description':"You can customize the field according to your business requirement",
  'update.links':'Update Links',
  'template.updated':'Template Updated successfully',
  'template.update.msg':'This template has been attached to the following payment links. Please select the links you want to update with the current template.',
  'not.now':'Not Now',
  'update.pages':'Update Links',
  'update.single.page':'Update 1 Link',
  'update.multiple.pages':'Update $pages Links',
  'empty.error':`can't be empty`,
  'rang.error':'should be between $min to $max characters',
  'valid.text.error':'Please enter valid text',
  'add.a.field':'Please add fields',
  'template.updated.msg':'Template updated successfully',
  'retry': 'Retry',
  'oops.error': 'Oops! Something went wrong'
};

_en.default = { error: 'Something went wrong...' };

_en.step2 = {
  title: 'JS Code',
  desc: 'Embed the JS Snippet below (in the body section of your HTML) for the customisation to take place.',
  copy: 'Copy JS Snippet',
  copied: 'Code Copied !!!',
  'copied.opps': 'Oops, unable to copy',
  'server.integration': 'Server Integration',
  'server.desc': 'View detailed configurations and documentation at our'
};

_en.theme = {
  note: 'Please Note',
  'note.desc': 'Same settings will be applied to both integrations.',
  title: 'Checkout Page Customization',
  'save.error': 'Please enter correct color code or choose from color picker',
  'display.secure.label': `Display "Secured payments powered by Paytm"`,
  'display.secure.desc': `Displaying payments powered by Paytm helps sustain user's trust in payments and results in higher success rates.`,
  'autologin.label': `Support auto-login into Paytm`,
  'autologin.desc': `Auto-logging into Paytm allows users to quickly access 200M+ saved cards with Paytm resulting in faster checkouts.`,
  'sort.paymodes': `Sort payment instruments`,
  'select.theme': `Select theme for your checkout page`,
  'default.order': `Default specified by Paytm`,
  'customize.order': `Customize order`,
  'save.setting': `Save Settings`,
  'sort.paymode.title': `Drag and drop to re-order payment instruments`,
  'save.success': `Theme saved successfully`,
  'checkout.tab': 'JS Checkout',
  'redirection.tab': 'Checkout',
  mobile: 'Mobile',
  'gradient.label': 'Gradient effect',
  'gradient.desc':
    'A subtle style effect which makes the colour of the header and the pay button fade out from top to bottom',
  'invert.logo.label': 'Invert Logo',
  'invert.logo.desc': 'All-In-One Paytm logo can be customized as per theme',
  'select.color.head': 'Select color for different components of checkout page'
};

_en.checkout = {
  title: 'JS Checkout',
  preview: 'Preview',
  'checkout.tab': 'JS Checkout',
  'redirection.tab': 'Checkout',
  mobile: 'Mobile',
  web: 'Web',
  'generate.code': 'Generate JS Code',
  'get.api': 'Get API Keys'
};

_en['button'] = {
  'add':'Add',
  "create":"Create a Button",
  "create.info":"Customers will see this button to initiate Payment",
  "skip.to.review":"Skip to Review Detail",
  "proceed.to.review":"Proceed to Review Details",
  "proceed.donor":"Proceed to Donor Details",
  "donate.default.text":"Donate an amount of your choice",
  "donate.min.max.amount":"Set min and max amount limit",
  "amount.to.pay":"Amount to be paid",
  "pay":"Proceed to Pay",
  "next":"Next",
  "custom.msg":"Show a Cutom Message",
  "redirect.url":"Redirect URL",
  "automated.receipt":"Send automated Payment Receipts",
  "payment.reciept":"Send automated Payment Receipts",
  "custom.msg.info":"This message is shown after Successful payment and on Payment receipt",
  "redirect.url.info":"The customer would be redirected to this URL after Successful payment",
  "payment.reciept.info":"We will send payment confirmation receipt to customer",
  "success.placholder":"Enter Payment Success Message",
  "fail.placholder":"Enter Payment Failure Message",
  "success.url.placholder":"Enter Payment Success Redirect URL",
  "fail.url.placholder":"Enter Payment Failure Redirect URL",
  "URL.error":"Please enter a valid URL",
  "no.preview":"No preview",
  "page.preview":"Payment page Preview",
  "no.preview.info.line1":"Add fields to view preview.",
  "no.preview.info.line2":"Amount fields can be used to list your products. You can also add more fields to collect additional information from your customers.",
  "preview.btn":"Button preview",
  "no.btn.preview.info":"Select a Button Type to see preview",
  'create.button' : 'Create Button',
  'save':'Save',
  'save.template':'Save template',
  'proceed':'Proceed',
  'select.btn':'Select a Button Type',
  'select.btn.help':'Pick a button which meets your requirements and get a head start on collecting payments',
  'pay.now': 'Pay Now',
  "field.name": "Field Name",
  "enter.field.name": "Enter Field Name",
  "enter.help.text": "Enter help Text",
  "after.payment": "After a Successful Payment",
  "after.payment.help": "Custom Message \u0026 Redirect URL",
  "donate.title" : "Donate Now",
  "max.amt.error" : "Maximum amount should be more than minimum amount",
  "no.amt" : "No amount Limits",
  'min.amount':'Minimum Amount',
  'max.amount':'Maximum Amount',
  'edit.button' : 'Edit Button',
  'update.button' : 'Update Button'
}
_en['preview']  ={
  "payment.details":"Payment Details"
}

_en.subscription = {
  name: 'Name',
  email: 'Email',
  mobile: 'Mobile',
  'subscription.at': 'Your Subscription at',
  'subscription.for': 'subscription for',
  'subscription.details': 'subscription details',
  'your.subs': 'Your Subscription at',
  'plan.desc': 'Plan Name and Description',
  'plan.amount': 'Plan Amount',
  'next.bill': 'Next Billing Date',
  'valid.till': 'Subscription Valid Till',
  'first.payment': 'FIRST PAYMENT',
  'next.payment': 'NEXT PAYMENTS',
  'footer.text': '100% Secure Payments Powered by Paytm',
  upto: 'upto',
  'pay.info':
    'IMPORTANT: Please ensure that you only pay to merchants you already know. Never make a payment to a non-trusted merchant for offers or prizes as it may be a scam',
  'next.on.demand': 'Upto \u20b9$amount will be charged until the subscription is valid',
  'next.fixed.interval':
    '$frequency after the first payment upto \u20b9$amount will be charged until the subscription is valid',
  'first.amount': 'Amount',
  inclusive: '(inclusive of one time charge)',
  'upto.min': 'upto \u20b9$amount may be deducted from your bank',
  'is.active': 'Your subscription is active',
  'trial.period': 'TRIAL PERIOD',
  'trial.text': '$time day trial period',
  DAY: ' Per Day',
  MONTH: ' Per Month',
  YEAR: ' Per Year',
  WEEK: ' Per Week',
  QUARTER: ' Every Quarter',
  BI_MONTHLY: ' Every 2 Months',
  SEMI_ANNUALLY: ' Every Half-year',
  FORTNIGHT: ' Every Fortnight',
  'show.more': 'Show more',
  'merchant.name': 'Merchant name',
  'confirm.cancel': 'Confirm Cancellation',
  'cancel.warning': 'If you cancel now, you can still access your subscription till',
  'cancel.msg': 'You can still access your subscription till',
  'okay.got.it': 'Ok. got it',
  'proceed.cancel': 'Proceed to Cancel',
  'not.now': 'Not Now',
  'mobile.number': 'Mobile Number',
  update: 'Update',
  'update.mobile': 'Update Mobile No.',
  'verify.number': 'Verify Mobile Number',
  'enter.otp.mobile': 'Enter OTP sent to mobile no.',
  otp: 'One Time Password (OTP)',
  'resend.otp': 'Resend OTP',
  confirm: 'Confirm',
  'failed.resend.otp': 'Failed to resend OTP. No attempts left!',
  'sent.success': 'OTP resent Successfully.',
  'attempt.left': 'attempt left',
  contact: 'Contact Merchant',
  'pay.history': 'Payment History',
  cancel: 'Cancel Subscription',
  'invalid.otp': 'Please enter a valid OTP',
  'email.id': 'Email ID',
  'update.email': 'Update Email ID',
  'proceed.to.pay': 'Proceed to Pay',
  'amount.to.paid': 'Amount to be paid',
  'oops.error': 'Oops! Something went wrong',
  retry: 'Retry'
};

export default _en;



// WEBPACK FOOTER //
// ./locale/en.js